/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

require('bootstrap-sweetalert');

jQuery(function ($) {
    'use strict';

    $('.delete,[data-waring-message]').on('click', function (event) {
        const href    = $(this).data('href') || $(this).attr('href');
        const title   = "Are you sure?";
        const message = $(this).data('waring-message') || null;
        event.stopPropagation();
        event.preventDefault();

        swal({
                title              : title,
                text               : message,
                showCancelButton   : true,
                confirmButtonClass : "btn-sm btn-danger",
                cancelButtonClass  : "btn-sm",
                confirmButtonText  : "Yes, delete it!",
            }, function (isConfirm) {
                if (isConfirm) {
                    window.location.href = href;
                }
            }
        );
    });

    if (window.swalMessage) {
        swal(window.swalMessage.text, '', window.swalMessage.type);
    }

});
